export default __webpack_public_path__ + "static/media/item-3.8e2fa51d.webp";